import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Footer } from '../shared/ui/footer/footer';
import { Header } from '../shared/ui/header/header';
import { LayoutService } from '../core/services/layout.service';
import { Sidebar } from '../shared/ui/sidebar/sidebar';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.html',
  styleUrl: './site-layout.scss',
  imports: [RouterOutlet, Header, Footer, Sidebar],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteLayout {
  readonly layoutService = inject(LayoutService);
}
